import { useAccountApi } from '@hooks/api/account/useAccountApi';
import { accountApiKeys } from '@hooks/api/account/useAccountApi';
import { useGetApi } from '@hooks/api/useGetApi';

import type { GetApiOptions, GetEntity } from '../../../types/api';
import type { UserProfile } from '../../../types/auth';

export function useGetAccount(
  { id = '' }: GetEntity,
  options?: Partial<GetApiOptions<UserProfile>>
) {
  const api = useAccountApi();
  return useGetApi({
    enabled: !!id,
    queryKey: accountApiKeys.get(id),
    request: () => api.get(id),
    ...options,
  });
}
